import React, { useEffect } from 'react';
import { verifyMagicLink } from  '../api/index';
import { useNavigate } from 'react-router-dom';

const RedirectPage = () => {

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const navigation = useNavigate();
  console.log(typeof token);

  const verifyToken = async (token) => {
    if(window.localStorage.getItem('authToken')){
      navigation('/');
    }
    try {
    const data =  await verifyMagicLink(token);
    console.log(data);
    
    window.localStorage.setItem('authToken', data.token);
    window.localStorage.setItem('student', JSON.stringify(data.student));
    navigation('/');
    } catch (error) {
      console.error('Error verifying token:', error);
      if(error.code === "duplicate_key_value"){
        navigation('/login');
      }
      // Redirect to the login page in case of an error
    }
  };

  useEffect(() => {
    
    if (token) {
      verifyToken(token);
    }
  }, []);

  return (
    <div>
      <h1>Redirecting...</h1>
    </div>
  );
};

export default RedirectPage;